/* eslint-disable @typescript-eslint/no-var-requires */
const iconMarkerSuccess = require('../../../../images/map-markers/iconSuccess32.svg')
const iconMarkerServicedown = require('../../../../images/map-markers/iconServiceDown24.svg')
const iconMarkerBlocked = require('../../../../images/map-markers/iconBlocked24.svg')
const iconMarkerPartiallyActive = require('../../../../images/map-markers/iconPartiallyActive24.svg')
const iconMarkerNoConsumeData = require('../../../../images/map-markers/iconNotConsumingData24.svg')

export const markerStatusMap = (status) => {
	let url = ''
	if (status === 'Optimal' || status === 'Active') {
		url = iconMarkerSuccess
	} else if (status === 'Degraded' || status === 'Intermittent') {
		url = iconMarkerPartiallyActive
	} else if (status === 'Issues') {
		url = iconMarkerServicedown
	} else if (status === 'No Data') {
		url = iconMarkerBlocked
	} else if (status === 'Idle') {
		url = iconMarkerNoConsumeData
	} else {
		url = ''
	}
	return {
		url,
	scaledSize: new window.google.maps.Size(16, 16), // scale the icon
	origin: new window.google.maps.Point(0, 0),
	anchor: new window.google.maps.Point(16, 16), // bottom center (adjust as needed)
	}
}